import { render, staticRenderFns } from "./AppAcceptCookiesBanner.vue?vue&type=template&id=73f95620&scoped=true"
import script from "./AppAcceptCookiesBanner.vue?vue&type=script&lang=ts"
export * from "./AppAcceptCookiesBanner.vue?vue&type=script&lang=ts"
import style0 from "./AppAcceptCookiesBanner.vue?vue&type=style&index=0&id=73f95620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f95620",
  null
  
)

export default component.exports